__turbopack_context__.v({
  "arrow": "live-categories-module-sass-module__qWU0iW__arrow",
  "categoryItem": "live-categories-module-sass-module__qWU0iW__categoryItem",
  "categoryItemsContainer": "live-categories-module-sass-module__qWU0iW__categoryItemsContainer",
  "categoryItemsList": "live-categories-module-sass-module__qWU0iW__categoryItemsList",
  "container": "live-categories-module-sass-module__qWU0iW__container",
  "favoritesStar": "live-categories-module-sass-module__qWU0iW__favoritesStar",
  "gameCount": "live-categories-module-sass-module__qWU0iW__gameCount",
  "opened": "live-categories-module-sass-module__qWU0iW__opened",
});
